import React from 'react';
import { CampaignType } from '../../../../__generated__/graphql';
import { useCurrentUser } from '../../../../utils/CurrentUserContext';
import { useFormContext } from 'react-hook-form';
import SwitchField from './SwitchField';

const ECPMField = () => {
  const {isAgencyOrAdvertiser} = useCurrentUser()
  const {watch} = useFormContext()
  const campaignType = watch('type')

  return (
    <SwitchField name='ecpmOptimization' label='eCPM' hidden={isAgencyOrAdvertiser || campaignType !== CampaignType.Filler} />
  );
};

export default ECPMField;


